import { createActionGroup, props, union } from '@ngrx/store';

export const CheckInActions = createActionGroup({
  source: 'CheckInActions',
  events: {
    'Set Passengers': props<{ passengers: string[] }>(),
    'Set BoundId': props<{ boundId: string }>(),
    'Set ClearPendingSeatsOnEntry': props<{ clearPendingSeatsOnEntry: boolean }>(),
    'Set ModifyCheckIn': props<{ isModifyCheckIn: boolean }>(),
  },
});

const _checkInUnion = union(
  Object.keys(CheckInActions).reduce((actions, key) => (actions[key] = CheckInActions[key]), {})
);

export type CheckInActionsUnion = typeof _checkInUnion;
